import React, { useState } from 'react'
import * as Yup from 'yup'
import { useAuth } from '../core/Auth'
import apiService from "../../../../services/api.service";
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import clsx from "clsx";

const loginSchema = Yup.object().shape({
    email: Yup.string()
        .email('Wrong email format')
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Email is required'),
    password: Yup.string()
        .min(3, 'Minimum 3 symbols')
        .max(50, 'Maximum 50 symbols')
        .required('Password is required'),
})

const initialValues = {
    email: '',
    password: '',
}

export function Login() {
    const [loading, setLoading] = useState(false)
    const {saveAuth, setCurrentUser} = useAuth()
    const [loginFail, setLoginFail] = useState(false)

    const {register, handleSubmit, formState: {isValid}}
        = useForm({
        initialValues,
        validationSchema: loginSchema,
        resolver: yupResolver(loginSchema),
    })

    async function onSubmit(data) {
        setLoading(true)
        try {
            const response = await apiService.login(data.email, data.password)
            if (response) {
                saveAuth(response)
                setCurrentUser(response)
            } else {
                setLoading(false)
                setLoginFail(true)
            }
        } catch (error) {
            saveAuth(undefined)
            setLoading(false)
            setLoginFail(true)
        }
    }

    return (
        <div className={ "LoginBox" }>
            <img alt={ "Logo" } src={ "/media/logos/homeLogo.svg" } className={ "w-[212px] h-[40px] ml-[30px]" }/>
            <form
                onSubmit={ handleSubmit(onSubmit) }
                noValidate
                id='kt_login_signin_form'
                className={ "w-full" }
            >
                <div className={ clsx("NewStrategyInputSection","mb-4") }>
                    <div className={ "NewStrategyInputTitle" }>Email</div>
                    <input className={ "NewStrategyInput" }
                           { ...register("email") }
                           placeholder='Email'
                           id="EmailInput"
                           type='email'
                           name='email'
                           autoComplete='off'/>
                </div>
                <div className={ "NewStrategyInputSection" }>
                    <div className={ "NewStrategyInputTitle" }>Password</div>
                    <input className={ "NewStrategyInput" }
                           { ...register("password") }
                           placeholder='Password'
                           id="PasswordInput"
                           type='password'
                           autoComplete='off'/>
                </div>
                { loginFail &&
                    <div className={ "flex gap-2 mt-4" }>
                        <img alt={ "Logo" } src={ "/media/icons/error.png" } className={ "w-4 h-4" }/>
                        <div className={ "text-xs text-[#B91C1C]" }>
                            Your email and/or password are incorrect, please try again. If there was a mistake, contact
                            your
                            administrator.
                        </div>
                    </div>
                }
                <div className={ "mt-6 flex items-center gap-6 w-full" }>
                    <button
                        type='submit'
                        id='kt_sign_in_submit'
                        className={ clsx("PrimaryButton", "w-full") }
                        disabled={ !isValid }
                    >
                        { !loading && <span>Login</span> }
                        { loading && (
                            <span className='indicator-progress'>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                        ) }
                    </button>
                </div>
            </form>
        </div>
    )
}